import {
  UserTimer3NowBlindWrapper,
  UserTimer3TopWrapper,
  UserTimer3TimerInfoWrapper,
  UserTimer3Wrapper,
  Timer3Background,
  UserTimer3BlindWrapper,
  Timer3LeftItemWrapper,
  Timer3PrizeItemTop3,
  Timer3PrizeItem,
  Timer3PrizeListWrapper,
  Timer3PrizeWrapper,
  UserTimer3InfoWrapper,
} from "./styles/vertical";
import { formatNumber } from "../../../utils/timer";
import AdVideo from "../../../component/AdVideo";
import { Timer1LeftWrapper } from "../timer2/styles/vertical";
import { Timer5Header } from "../timer5/styles/vertical";
import { Timer2Notice } from "../timer3/styles/vertical";
import Timer3PrizeBox from "../timer3/components/vertical-prize-box";
import { useClock } from "../hooks/use-clock";
import { Helmet } from "react-helmet";

const UserVerticalTimer1 = () => {
  const {
    timeInfo,
    userCount,
    reBuyInUserCount,
    entryUserCount,
    adOnUserCount,
    stack,
    avgStack,
    pub,
    coverImage,
    backgroundImage,
    isAd,
    setIsAd,
    data,
    visibleRanks,
    getNextBlind,
    getNowBlind,
    getData,
    subPrizeFont,
  } = useClock();

  const findNextLevel = () => {
    if (timeInfo.currentLevel?.type !== "BREAK") {
      return 0;
    }

    if (!data) {
      return 0;
    }

    const level = data.structure[timeInfo.currentLevel.ord].level;

    return level;
  };

  return (
    <>
      <Helmet>
        <title>{data?.title}</title>
      </Helmet>
      <UserTimer3Wrapper>
        {backgroundImage && (
          <Timer3Background backgroundImage={backgroundImage} />
        )}

        <UserTimer3TopWrapper>
          <Timer5Header>
            <div className="tournament-info-row">
              {coverImage && <img src={coverImage} alt="펍 로고" />}
              <div className="titleWrapper">
                <div className="title">{data?.title}</div>
                <div className="type">
                  <span>{data?.subTitle}</span>
                </div>
              </div>
            </div>
            <div className="pub-name">{pub?.cafeName}</div>
          </Timer5Header>
          <UserTimer3TimerInfoWrapper>
            <div className="now-level">
              {timeInfo?.elapsedTimeMs && timeInfo?.elapsedTimeMs > 0 ? (
                timeInfo.currentLevel?.type === "LEVEL" ? (
                  `현재\u00A0\u00A0\u00A0${timeInfo.currentLevel.level}LV`
                ) : (
                  <span className="break-text">
                    BREAK(다음 {findNextLevel()}LV)
                  </span>
                )
              ) : (
                "시작 준비중"
              )}
            </div>

            <div
              className={`time ${
                timeInfo.currentLevel?.type === "BREAK" ||
                (timeInfo?.elapsedTimeMs && timeInfo?.elapsedTimeMs < 0)
                  ? "break"
                  : ""
              }`}
            >
              {timeInfo.remainingTimeInCurrentLevel}
            </div>
          </UserTimer3TimerInfoWrapper>
        </UserTimer3TopWrapper>
        <UserTimer3BlindWrapper>
          <UserTimer3NowBlindWrapper>
            <div className="title">현재 BLINDS</div>
            <div className="value">{getNowBlind()}</div>
          </UserTimer3NowBlindWrapper>
          <UserTimer3NowBlindWrapper style={{ height: "136px" }}>
            <div className="title">다음 BLINDS</div>
            <div className="value">{getNextBlind()}</div>
          </UserTimer3NowBlindWrapper>
        </UserTimer3BlindWrapper>
        <UserTimer3InfoWrapper>
          <Timer1LeftWrapper>
            <Timer3LeftItemWrapper>
              <div className="title">PLAYERS</div>
              <div className="value">{`${userCount} / ${
                adOnUserCount + reBuyInUserCount + entryUserCount
              }`}</div>
            </Timer3LeftItemWrapper>
            <Timer3LeftItemWrapper>
              <div className="title">TOTAL TIME</div>
              <div className="value">{timeInfo.elapsedTime}</div>
            </Timer3LeftItemWrapper>
            <Timer3LeftItemWrapper>
              <div className="title">TOTAL STACKS</div>
              <div className="value">{formatNumber(stack)}</div>
            </Timer3LeftItemWrapper>
            <Timer3LeftItemWrapper>
              <div className="title">AVG STACKS</div>
              <div className="value">{formatNumber(avgStack)}</div>
            </Timer3LeftItemWrapper>
            <Timer3LeftItemWrapper>
              <div className="title">NEXT BREAK</div>
              <div className="value">{timeInfo.timeUntilNextBreak}</div>
            </Timer3LeftItemWrapper>
          </Timer1LeftWrapper>
          <Timer3PrizeWrapper>
            <Timer3PrizeListWrapper>
              <div className="title">PRIZE POOL</div>
              <div className="list-wrapper">
                {data?.moneyInChip.map((item: any, index: number) =>
                  index < 3 ? (
                    <Timer3PrizeItemTop3>
                      <div className={`rank`}>{`${index + 1}${
                        index === 0
                          ? "st"
                          : index === 1
                            ? "nd"
                            : index === 2
                              ? "rd"
                              : "th"
                      }`}</div>
                      <Timer3PrizeBox
                        data={data}
                        item={item}
                        index={index}
                        subPrizeFont={subPrizeFont}
                      />
                    </Timer3PrizeItemTop3>
                  ) : (
                    visibleRanks.includes(index + 1) && (
                      <Timer3PrizeItem length={data?.moneyInChip.length}>
                        <div className={`rank`}>{`${index + 1}${
                          index === 0
                            ? "st"
                            : index === 1
                              ? "nd"
                              : index === 2
                                ? "rd"
                                : "th"
                        }`}</div>
                        <Timer3PrizeBox
                          data={data}
                          item={item}
                          index={index}
                          subPrizeFont={subPrizeFont}
                        />
                      </Timer3PrizeItem>
                    )
                  ),
                )}
              </div>
            </Timer3PrizeListWrapper>
            <Timer2Notice
              dangerouslySetInnerHTML={{
                __html: data?.notice
                  ? data.notice.replace(/\n/g, "<br />")
                  : "",
              }}
            />
          </Timer3PrizeWrapper>
        </UserTimer3InfoWrapper>
        {isAd && (
          <AdVideo
            coverImage={coverImage}
            onClose={() => setIsAd(false)}
            data={data}
            timeInfo={timeInfo}
            stack={stack}
            avgStack={avgStack}
          />
        )}
      </UserTimer3Wrapper>
    </>
  );
};

export default UserVerticalTimer1;
